import styled from 'styled-components';
import { borderRadius, paddings } from '~/styled/GlobalStyles';

interface Props {
  $mainMenu: boolean;
}

export const NavMenu = styled.ul<Props>`
  background-color: ${({ theme, $mainMenu }) =>
    $mainMenu ? theme.colors.surface : theme.colors.background};
  color: ${({ theme }) => theme.colors.onSurface};
  border-radius: ${() => borderRadius.default};
  margin: 0;
  padding: 0;
  list-style: none;
`;
export const Nav = styled.nav`
  position: relative;
  padding: ${() => paddings.defaultPadding};
`;
